<div class="orders-page">

  <div class="page-header">
    <div class="page-header-text">
      <h2>{{ 'page.cancelled_title' | translate }}</h2>
      <p>{{ 'page.cancelled_subtitle' | translate }}</p>
    </div>
    <span class="total-badge" *ngIf="totalCount">
      <span class="material-symbols-outlined">block</span>
      {{ totalCount }} {{ 'page.orders_count' | translate }}
    </span>
  </div>

  <div class="app-card filters-card">
    <div class="filters-grid">
      <div class="filter-group">
        <label class="filter-label">
          <span class="material-symbols-outlined">phone</span>
          {{ 'filter.phone' | translate }}
        </label>
        <input
          (input)="phoneNumberSearch($event)"
          type="search"
          class="filter-input"
          [(ngModel)]="clientPhoneNumberValue"
          [placeholder]="'ph.search_phone' | translate"
        />
      </div>
      <div class="filter-group">
        <label class="filter-label">
          <span class="material-symbols-outlined">inventory_2</span>
          {{ 'filter.product' | translate }}
        </label>
        <input
          type="search"
          (input)="productNameSearch($event)"
          class="filter-input"
          [(ngModel)]="productNameValue"
          [placeholder]="'ph.search_product' | translate"
        />
      </div>
      <div class="filter-group">
        <label class="filter-label">
          <span class="material-symbols-outlined">payments</span>
          {{ 'filter.payment' | translate }}
        </label>
        <select
          class="filter-input"
          [(ngModel)]="paymentStatusSelectModel"
          (ngModelChange)="paymentStatusFilter($event)"
        >
          <option value="all">{{ 'status.all' | translate }}</option>
          <option value="true">{{ 'status.paid' | translate }}</option>
          <option value="false">{{ 'status.unpaid' | translate }}</option>
        </select>
      </div>
      <div class="filter-group">
        <label class="filter-label">
          <span class="material-symbols-outlined">local_shipping</span>
          {{ 'filter.delivery' | translate }}
        </label>
        <select
          class="filter-input"
          [(ngModel)]="deliveryStatusSelectModel"
          (ngModelChange)="deliveryStatusFilter($event)"
        >
          <option value="all">{{ 'status.all' | translate }}</option>
          <option value="true">{{ 'status.delivered' | translate }}</option>
          <option value="false">{{ 'status.undelivered' | translate }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="app-card table-card">
    <div class="table-wrap">
      <table mat-table [dataSource]="allCancelledOrders" matSort matSortDirection="desc" matSortDisableClear>

        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>#</th>
          <td mat-cell *matCellDef="let element" class="cell-id">{{ element?.id }}</td>
        </ng-container>

        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.client' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <div class="client-cell">
              <span class="client-avatar">{{ (row?.client?.username || '?')[0] | uppercase }}</span>
              <span class="client-name">{{ row?.client?.username }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.date' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="cell-date">{{ row?.issue_date | date : "d MMM y · HH:mm" }}</td>
        </ng-container>

        <ng-container matColumnDef="packages">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.packages' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="count-chip">{{ row?.packages?.length }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.method' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge method">{{ (row?.cashed ? 'status.cash' : 'status.vodafone') | translate }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="paid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.paid' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge" [class.paid]="row?.paid" [class.unpaid]="!row?.paid">
              {{ (row?.paid ? 'status.paid' : 'status.unpaid') | translate }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="delivered">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.delivery' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="status-badge" [class.delivered]="row?.delivered" [class.pending]="!row?.delivered">
              {{ (row?.delivered ? 'status.delivered' : 'status.pending') | translate }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="cancelledReason">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.reason' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="cancelled-reason">{{ row?.reason || '—' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="totalPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.total' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="price-cell">
            {{ row?.total_price }}<span class="currency"> LE</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (mouseover)="onRowHovered(row)"
          (mouseleave)="handleMouseLeave()"
          (mousedown)="orderDetails(row?.id)"
          [class.row-hover]="row === selectedRow"
        ></tr>
      </table>
    </div>

    <div class="empty-state" *ngIf="allCancelledOrders?.length === 0">
      <div class="empty-state-icon">
        <span class="material-symbols-outlined">block</span>
      </div>
      <h3>{{ 'empty.cancelled' | translate }}</h3>
      <p>{{ 'empty.orders_sub' | translate }}</p>
    </div>

    <mat-paginator
      [pageSize]="10"
      [length]="totalCount"
      [pageIndex]="page - 1"
      (page)="changePage($event)"
    ></mat-paginator>
  </div>

</div>
